import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import { SelectPicker, toaster, Message } from "rsuite";
import mapleTopLight from "../../assets/images/maple-top-light.png";
import { azureLogin, loginXerxes } from "../../api";
import { message } from "antd";

import "rsuite/dist/rsuite.min.css";
import AuthLoadingScreen from "../../util/AuthLoadingScreen/AuthLoadingScreen";

const LoginPage = () => {
  const [chromeMessageShown, setChromeMessageShown] = useState(false);
  const data = [
    { label: "Comcast", value: "azure" },
    { label: "Videotron", value: "xerxes-videotron" },
    { label: "Rogers", value: "xerxes-rogers" },
  ];
  const [isLoading, setIsLoading] = useState(false);

  const selectorMenuStyles = {
    color: "#b8b8ed",
  };

  const handleSelectChange = async (value) => {
    try {
      setIsLoading(true);
      localStorage.setItem('loginType', value);
      if (value === "azure") {
        await azureLogin();
      } else if (value === "xerxes-videotron" || value === "xerxes-rogers") {
        await loginXerxes();
      }
    } catch (error) {
      const errorMessage =
        error?.message || "Unable to authenticate login. Please try again.";
      message.error(errorMessage);
    }
  };

  useEffect(() => {
    const isChromeBrowser =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    if (!isChromeBrowser && !chromeMessageShown) {
      message.warning("Please use Chrome browser for better experience", 5);
      setChromeMessageShown(true);
    }
  }, [chromeMessageShown]);

  useEffect(() => {
    const loginMessage = sessionStorage.getItem("loginMessage");
    if (loginMessage) {
      toaster.push(
        <Message type="warning" showIcon closable>
          {loginMessage}
        </Message>,
        { placement: "topCenter", duration: 10000 }
      );
      sessionStorage.removeItem("loginMessage");
    }
  }, []);

  return (
    <div className="login-main-container" data-testid="login-page">
      {isLoading ? (
        <AuthLoadingScreen />
      ) : (
        // <div className="login-main-container" data-testid="login-page">
          <div className="login-container">
            <div>
              <img alt="maple-logo" src={mapleTopLight} />
            </div>
            <div className="sso-selector">
              <SelectPicker
                data={data}
                searchable={false}
                style={{ width: 224 }}
                placeholder="Sign in with SSO"
                menuStyle={selectorMenuStyles}
                onChange={handleSelectChange}
              />
            </div>
            <div>
              Comcast employees request access via{" "}
              <a href="https://mycomcastaccess.comcast.com/identityiq/home.jsf" target="_blank" rel="noreferrer">myComcastAccess</a>
            </div>
            <hr className="divider" />
            {/* <div className="login-failure">
          Unable to authenticate login.<br />Please try again.
        </div> */}
            {/* <div className="login-failure">
          Session Expired.<br />Login again.
        </div> */}
          </div>
        // </div>
      )}
    </div>
  );
};

export default LoginPage;
